import MediaControl from '@Components/Shared/MediaControl';
import PhotoListing_SimilarListings from '@Components/Listings/PhotoListing_SimilarListings';
import CategoryInformation from '@Components/Shared/CategoryInformation';
import ready from 'document-ready';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import translator from '@Components/Utilities/Translator';
import ListingCarousel from '@Components/Shared/ListingCarousel';

const PhotoListingDetail = (props) => {
    return (
        <div>
            <CategoryInformation {...props.CategoryInformation} />
            {props.BreadCrumbs && props.BreadCrumbs.length > 0 &&
                <div className='breadcrumbs'>
                    <div className='container cf'>
                        <ul>
                        <li><a className='home fas' href={props.BreadCrumbs ? props.BreadCrumbs[0].Url : "/"}><i className='fas fa-home' aria-hidden='true'></i></a><i class="fas fa-angles-right"></i></li>
                        {props.BreadCrumbs.map((value, index) => (index > 0 ? <li key={value.Label + index}>{value.Url ? <a className='fas' href={value.Url}><span className='arial-font-normal'>{value.Label}</span></a> : value.Label}<i class="fas fa-angles-right"></i></li> : null))}
                        </ul>
                    </div>
                </div>}
            <div className='detail-img-carousel'>
                {props.MediaModel && props.MediaModel.Media && props.MediaModel.Media.length > 0 ?
                    <MediaControl {...props.MediaModel} /> :
                    <div className='media-control-no-photo' />}
            </div>
            <div className='main'>
                <div className='container cf'>
                    <h1>{props.PageHeader}</h1><br />
                    {(!props.ForSale && !props.ForCharter) &&
                        <div className="sale-banner">
                            <i className="fas fa-info-circle"></i><strong>This listing is currently not for sale or available for charter</strong>
                        </div>}
                    <div className='column4'>
                        <a id='photo-detail-similar-cnt' className='btn controller ts-button' target='_blank' href={props.SimilarListingsOnCNT} onClick={() => gtmPushEvent(gtmEventType.controllerButtonClick)} aria-label={props.SimilarListingsOnCNTText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{props.SimilarListingsOnCNTText}<br /><img src='/Content/Aircraft/images/controller-logo.png' alt="" /></a>
                    </div>
                    <div className='column4'>
                        <a id='photo-detail-similar-chb' className='btn charter ts-button' target='_blank' href={props.SimilarListingsOnCHB} onClick={() => gtmPushEvent(gtmEventType.charterHubButtonClick)} aria-label={props.SimilarListingsOnCHBText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{props.SimilarListingsOnCHBText}<br /><img src='/Content/Aircraft/images/charter-hub-logo.png' alt="" /></a>
                    </div>
                    <div className='column4 last'>
                        <a id='photo-detail-acc-link' className='btn acc ts-button' target='_blank' href={props.ACCUrl} aria-label={"See Aircraft Operating Costs On (" + translator.translate('sandhills.opensinanewtab') + ")"}>See Aircraft Operating Costs On<br /><img src='/Content/Aircraft/images/acc.png' alt='Aircraft Cost Calculator' /></a>
                    </div>
                    <div className='clear' /><br /><br />
                    {props.CategorySpecs && props.CategorySpecs.Specs && props.CategorySpecs.Specs.length > 0 &&
                        <div className='column6'>
                            <h3>{props.CategorySpecs.ListName}</h3><br />
                            {props.CategorySpecs.Specs.map(value =>
                                <div key={value.SpecGroupID}>
                                    <h4>{value.GroupName}</h4>
                                    {Object.keys(value.Specs).map((key, index) =>
                                        <div key={value.listName + index} className='spec'>
                                            <div className='spec-title'>{value.Specs[key].LabelDisplayText}</div>
                                            <div className='spec-detail'>{value.Specs[key].Value}</div>
                                        </div>
                                    )}
                                </div>)}
                        </div>}
                    <div className='clear' /><br /><br />
                    {props.ACCUrl &&
                        <div className='acc-banner'>
                            <div className='banner-inner'>
                                <h2>Interested in operating costs?</h2>
                                <img src='/content/images/acc/acc-logo.png' alt='Aircraft Cost Calculator' /> <span>has the answer</span>
                            </div>
                            <a target='_blank' href={props.ACCUrl} aria-label={"Click Here to find your Operating Cost (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                <strong><span>Click Here to </span>find your Operating Cost</strong></a>
                        </div>}
                    <div className='clear' /><br /><br />
                    {props.SimilarListings && props.SimilarListings?.Cards?.length > 0 &&
                        <ListingCarousel {...props.SimilarListings} translationKey='sandhills.recommendedforyou' />
                    }
                    <div className='aircraft-disclaimer'>{props.DisclaimerText}</div>
                </div>
            </div>
        </div>
    );
};

export default PhotoListingDetail;
global.PhotoListingDetail = PhotoListingDetail;